import EventBox from "./EventBox"

export default EventBox
